module.exports = __webpack_public_path__ + "6602ba518a04d572c1324c53d34a7849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-you-are-welcome.png
// module id = 2049
// module chunks = 4